/**
 * Resource đề nghị cam kết chi
 * TVTOAN 15/05/2023
 */
export default {
  BUCommitExpenseList: {
    Title: 'Đề nghị cam kết chi',
  },
  BUCommitExpenseDetail: {
    Title: 'Đề nghị cam kết chi',
    OptionOne: 'Kinh phí thường xuyên',
    OptionTwo: 'Kinh phí đầu tư',
    ProjectCode: 'Mã dự án đầu tư',
    ProjectName: 'Tên dự án đầu tư',
    Provider: 'Nhà cung cấp',
    ProviderCodeInTabmis: 'Mã NCC trên TABMIS',
    ProviderCodeInTabmisTooltip: 'Mã nhà cung cấp trên tabmis',
    BankAccount: 'Tài khoản NH',
    BankAccountTooltip: 'Tài khoản ngân hàng',
    BankName: 'Tại ngân hàng',
    ContractNo: 'Số HĐ giấy',
    ContractNoTooltip: 'Số hợp đồng giấy',
    SignDate: 'Ngày ký/Ngày hiệu lực',
    ContractFrameNo: 'Số HĐK đã CKC',
    ContractFrameNoTooltip: 'Số hợp đồng khung đã cam kết chi',
    ContractAmount: 'Giá trị hợp đồng giấy',
    PrevYearCommitmentAmount: 'Số tiền đã CKC các năm trước',
    PrevYearCommitmentAmountTooltip: 'Số tiền đã cam kết chi các năm trước',
    CTReference: 'CT tham chiếu',
    CTReferenceTooltip: 'Chứng từ tham chiếu',
    RequestDate: 'Ngày đề nghị CKC',
    RequestDateTooltip: 'Ngày đề nghị cam kết chi',
    NoteDate: 'Ngày KBNN ghi sổ',
    NoteDateTooltip: 'Ngày kho bạc nhà nước ghi sổ',
    CKCNo: 'Số cam kết chi',
  },
};
